import styled from 'styled-components';
import { variables } from 'variables';

export const CreateTicketStep1SC = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.pageBackgroundColor};
  padding: ${variables.pageContentPadding}px;
  width: 100%;
  padding-right: 0;
  padding-bottom: 0;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const SearchUsername = styled.div`
  margin: 1em 0;
`;

export const Checkboxes = styled.div`
  margin-top: 3em;
`;

export const Lang = styled.div`
  display: flex;
  margin-top: 1em;
  cursor: pointer;
  h6 {
    margin: 0;
    margin-top: 3px;
    font-weight: bold;
  }
`;

export const Search = styled.div`
  margin-right: 10px;
  display: flex;
  flex-direction: column;
`;

export const SearchResult = styled.div`
  margin-top: 1.5em;
  margin-bottom: 3em;
  .userInfo {
    margin-left: 4px;
    .email {
      display: flex;
      margin-top: 10px;
      i {
        color: ${(props) => props.theme.primaryDarkColor};
        font-size: 5px;
        margin-top: 3px;
        margin-right: 8px;
      }
      .email-address {
        margin: 0;
      }
    }
    .main-heading {
      font-weight: bolder;
      margin: 0;
    }
  }
`;

export const SearchContainer = styled.div`
  background: white;
  position: absolute;
  border-radius: 5px;
  z-index: 1000;
  margin-top: 5.7em;
  box-shadow: lightgray 0px 0px 24px 5px;
  .link {
    display: flex;
    padding: 1em;
    border-bottom: 1px solid ${(props) => props.theme.dividerColor};
  }
  h6 {
    margin: 0;
    color: black;
    cursor: pointer;
  }
  i {
    color: black;
    font-size: 10px;
    margin-top: 2px;
    margin-right: 12px;
  }
`;
